export const catalogQueryKeys = {
  all: ["catalog"],

  products: () => [...catalogQueryKeys.all, "products"],
  manufacturers: () => [...catalogQueryKeys.all, "manufacturers"],
  manufacturersList: () => [...catalogQueryKeys.all, "manufacturers-list"],
  goodsGroups: () => [...catalogQueryKeys.all, "goods-groups"],
  jobs: () => [...catalogQueryKeys.all, "jobs"],
  dcs: () => [...catalogQueryKeys.all, "dcs"],
  dealerCategories: () => [...catalogQueryKeys.all, "dealer-categories"],
  targetGroups: () => [...catalogQueryKeys.all, "target-groups"],
  saleoffices: () => [...catalogQueryKeys.all, "saleoffices"],
};
